import theme from "assets/theme";
import React, { useContext, useMemo } from "react";
import { StyleSheet, Text } from "react-native";
import { OrganizationContext } from "webContext/Organization.context";

export default function ClickStyledText({ children, style, ...rest }) {
  const { organizationColor } = useContext(OrganizationContext);

  const clickableStyle = useMemo(
    () =>
      StyleSheet.create({
        text: {
          color: organizationColor,
          fontWeight: theme.font.weight.semibold,
          textAlign: "center",
        },
      }),
    [organizationColor],
  );

  return (
    <Text style={[clickableStyle.text, style]} {...rest}>
      {children}
    </Text>
  );
}
